/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_From_Last_MonthInputs */

const en_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from last month`)
};

const de_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vom letzten Monat`)
};

const es_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`del mes pasado`)
};

const fr_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du mois dernier`)
};

const nl_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ten opzichte van vorige maand`)
};

const it_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dal mese scorso`)
};

const pt_br2_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs. mês passado`)
};

const pl_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z ostatniego miesiąca`)
};

const hu_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`az elmúlt hónapból`)
};

const ro_admin_dashboard_from_last_month = /** @type {(inputs: Admin_Dashboard_From_Last_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`din luna trecuta`)
};

/**
* | output |
* | --- |
* | "from last month" |
*
* @param {Admin_Dashboard_From_Last_MonthInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_from_last_month = /** @type {((inputs?: Admin_Dashboard_From_Last_MonthInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_From_Last_MonthInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_from_last_month(inputs)
	if (locale === "de") return de_admin_dashboard_from_last_month(inputs)
	if (locale === "es") return es_admin_dashboard_from_last_month(inputs)
	if (locale === "fr") return fr_admin_dashboard_from_last_month(inputs)
	if (locale === "nl") return nl_admin_dashboard_from_last_month(inputs)
	if (locale === "it") return it_admin_dashboard_from_last_month(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_from_last_month(inputs)
	if (locale === "pl") return pl_admin_dashboard_from_last_month(inputs)
	if (locale === "hu") return hu_admin_dashboard_from_last_month(inputs)
	return ro_admin_dashboard_from_last_month(inputs)
});
export { admin_dashboard_from_last_month as "admin.dashboard.from_last_month" }